const translations_en = require('../lang/locale-en.json')
const translations_pt_BR = require('../lang/locale-pt_BR.json')

const translationsMap = {
    'en': translations_en,
    'pt_BR': translations_pt_BR
}

export function configureLanguage($translateProvider,language) {
    // Configuração de linguagem
    
    $translateProvider.translations(language,translationsMap[language])
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.preferredLanguage(language);
}